import { fork } from 'redux-saga/effects'
import { sharedMCOnboardingSaga } from './shared'
import { inviteMCSaga } from './inviteMC'

export function* mcOnboardingSaga() {
  yield fork(sharedMCOnboardingSaga)
  yield fork(inviteMCSaga)
}
